import * as Sentry from '@sentry/react';
const notificationAudio = new Audio('/notification.m4a');

export function playNotificationSound() {
    notificationAudio.currentTime = 0;
    notificationAudio.play().catch((err) => {
        console.warn('Could not play notification sound:', err);
        Sentry.captureException(err);
    });
}

export async function checkAudioPermission(): Promise<boolean> {
    try {
        const testAudio = new Audio('/notification.m4a');
        testAudio.volume = 0;
        await testAudio.play();
        testAudio.pause();
        testAudio.src = '';
        return true;
    } catch {
        return false;
    }
}

export function unlockAudio() {
    const testAudio = new Audio('/notification.m4a');
    testAudio.volume = 0;
    testAudio.play()
        .then(() => {
            testAudio.pause();
            testAudio.src = '';
        })
        .catch(() => {});
}
